import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHeader } from "@/components/Reveal";
import { FAQ } from "@/lib/data";

const Faq = () => (
  <section id="faq" data-testid="faq-section" className="relative py-24 lg:py-32 bg-[#EEF3F9]">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeader
        center
        caption="FAQ"
        title="Les questions qu'on nous pose"
      />
      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="mt-12 space-y-4">
          {FAQ.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-accordion-item-${i}`}
              className="rounded-xl border border-slate-900/10 bg-white px-6 data-[state=open]:border-sky-400/40 transition-colors duration-300"
            >
              <AccordionTrigger className="text-left text-base font-semibold text-slate-900 hover:text-sky-600 hover:no-underline py-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-slate-500 leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
